import { useTranslation } from "react-i18next";
import { Globe, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { LANGUAGES } from "@/i18n";

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();

  const change = (code) => {
    i18n.changeLanguage(code);
    const lang = LANGUAGES.find((l) => l.code === code);
    document.documentElement.dir = lang?.dir || "ltr";
    document.documentElement.lang = code;
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-switcher"
          className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-full hover:bg-muted transition-colors text-xs uppercase tracking-widest"
          aria-label={t("nav.language")}
        >
          <Globe className="w-3.5 h-3.5" />
          <span className="font-medium">{i18n.language.toUpperCase().slice(0, 2)}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[200px]">
        <DropdownMenuLabel className="text-xs uppercase tracking-widest text-muted-foreground">
          {t("nav.language")}
        </DropdownMenuLabel>
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => change(l.code)}
            className="flex items-center justify-between cursor-pointer"
          >
            <span className="flex flex-col">
              <span className="text-sm">{l.nativeLabel}</span>
              <span className="text-[10px] uppercase tracking-widest text-muted-foreground">{l.label}</span>
            </span>
            {i18n.language.startsWith(l.code) && <Check className="w-3.5 h-3.5 text-gold-500" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
